/**
 * Pre-compiled pt-BR messages for DatePicker
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  "Time.enterTime": `Inserir hora`,
  "Time.enterTimeHour": `Inserir hora (hora)`,
  "Time.enterTimeHourMinute": `Inserir hora (hora e minutos)`,
  "Time.enterTimeHourMinuteSecond": `Inserir hora (hora, minutos e segundos)`,
  "Time.startTime": `Hora de início`,
  clearInput: `Limpar valores inseridos`,
};
